"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValleyBankDataError = exports.initValleyBankDataErrorsArray = void 0;
const initValleyBankDataErrorsArray = () => [];
exports.initValleyBankDataErrorsArray = initValleyBankDataErrorsArray;
const createValleyBankDataError = (params) => {
    return {
        identifier: params.identifier,
        identifierValue: params.identifierValue,
        errorMessage: params.errorMessage,
    };
};
exports.createValleyBankDataError = createValleyBankDataError;
//# sourceMappingURL=errors.js.map